import { render, staticRenderFns } from "./information-audit.vue?vue&type=template&id=1512b6bd&scoped=true"
import script from "./information-audit.vue?vue&type=script&lang=js"
export * from "./information-audit.vue?vue&type=script&lang=js"
import style0 from "./information-audit.vue?vue&type=style&index=0&id=1512b6bd&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512b6bd",
  null
  
)

export default component.exports